import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { designTokens, Flex } from "@itandi/itandi-bb-ui";
import { StatusCard } from "./StatusCard";

export type StatusCardItem = {
	count: number;
	description?: string;
	href: string;
	label: string;
	variant: "default" | "danger" | "warning" | "success";
};

export type StatusCardItems = DeepReadonly<StatusCardItem[]>;

type Props = {
	statusCards: StatusCardItems;
};

export function StatusCardList({ statusCards }: Props) {
	return (
		<Flex
			czz={{
				"@media (max-width: 480px)": {
					flexWrap: "wrap",
					gap: designTokens["spacing/xs"]
				}
			}}
			gap={designTokens["spacing/s"]}
			width="100%"
			wrap="nowrap"
		>
			{statusCards.map((statusCard) => (
				<StatusCard
					count={statusCard.count}
					description={statusCard.description}
					href={statusCard.href}
					key={statusCard.label}
					label={statusCard.label}
					variant={statusCard.variant}
				/>
			))}
		</Flex>
	);
}
